var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"variant":"warning"}},[_vm._v("\n  "+_vm._s(_vm.$t(
      "you have chosen to hide all the telephones from the classified view. this means that you will only be able to communicate via {site}'s messages",
      { site: _vm.domain }
    ))+".\n")])}
var staticRenderFns = []

export { render, staticRenderFns }